import { render, staticRenderFns } from "./joinActive.vue?vue&type=template&id=9d122de8&scoped=true"
import script from "./joinActive.vue?vue&type=script&lang=js"
export * from "./joinActive.vue?vue&type=script&lang=js"
import style0 from "./joinActive.vue?vue&type=style&index=0&id=9d122de8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d122de8",
  null
  
)

export default component.exports